module.exports = __webpack_public_path__ + "fonts/InformaPro-Medium.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/InformaPro-Medium.ttf
// module id = 31
// module chunks = 0